import React, { useEffect, useRef, useState } from "react";
import "./ExpenseForm.scss";
import { FaChevronDown, FaCloudUploadAlt } from "react-icons/fa";
import {
  saveExpense,
  updateExpense,
  getExpenseByID,
} from "../../services/api/ExpenseApi";
import { useToast } from "../../context/ToastContext";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { storage } from "../../utils/firebase";
import { BiUpload } from "react-icons/bi";
import { useAuth } from "../../context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import { useGlobalSettings } from "../../context/GlobalSettingsContext";
import { getBranchDetailsById } from "../../services/api/BranchApi";
import {
  getDistrictCasesByCourtRef,
  getHighCasesByCourtRef,
  getOtherCourtCasesAddedManuallyByCourtRef,
  getSupremeCourtCasesByCourtRef,
} from "../../services/api/CasesApi";
import { updateExpenseSettings } from "../../services/api/GlobalSettingsApi";
import CommonModal from "../../components/CommonModal/CommonModal";
import { uploadFileWithProgress } from "../../utils/ftpUploadUtils";


export const ExpenseForm = ({
  onSuccess,
  handleCancelExpenses,
  disabledCourtRef = false,
  initialData = null,
  onCancel = null,
  isModal = false,
}) => {
  const { expId } = useParams();
  const navigate = useNavigate();
  const { globalSettings, setGlobalSettings } = useGlobalSettings();


  const { company } = useAuth();
  const isEnt = company?.type === "ent";


  const [type, setType] = useState("");
  // Set default date to current system date and time in 'YYYY-MM-DDTHH:mm' format
  const getCurrentDateTimeLocal = () => {
    const now = new Date();
    const tzOffset = now.getTimezoneOffset() * 60000;
    return new Date(now - tzOffset).toISOString().slice(0, 16);
  };
  const [date, setDate] = useState(() => getCurrentDateTimeLocal());
  const [branchId, setBranchId] = useState("");
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");
  const [resourceType, setResourceType] = useState("");
  const [resourceName, setResourceName] = useState("");
  const [caseNumber, setCaseNumber] = useState("");
  const [documentUrl, setDocumentUrl] = useState("");
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [file, setFile] = useState(null);
  const { showToast } = useToast();
  const isEdit = !!expId || (!!initialData && !!initialData._id);
  const currentExpenseId = expId || initialData?._id;
  const [fetchedExpenseData, setFetchedExpenseData] = useState(null);


  const [branchesWithNames, setBranchesWithNames] = useState([]);


  const [ExpisDropdownOpen, setExpIsDropdownOpen] = useState(false);
  const [ExpselectedCourtTab, setExpSelectedCourtTab] = useState("high");
  const [ExpCases, setExpCases] = useState([]);
  const ExpdropdownRef = useRef();
  const modalRef = useRef(null);

  const addModalRef = useRef(null);

  const [showAddModal, setShowAddModal] = useState(false);
  const [addFieldType, setAddFieldType] = useState(""); // 'type' | 'resourceType' | 'resourceName'
  const [newFieldValue, setNewFieldValue] = useState("");
  const [isAddingNewField, setIsAddingNewField] = useState(false);


  const [isLoadingCases, setIsLoadingCases] = useState(false);
  const typeSelectRef = useRef(null);
  const hasFocusedRef = useRef(false);


  // Handle click outside modal to close
  useEffect(() => {
    const handleModalClickOutside = (event) => {
      if (isModal && modalRef.current && !modalRef.current.contains(event.target)) {
        if (onCancel) {
          onCancel();
        } else if (handleCancelExpenses) {
          handleCancelExpenses();
        }
      }
    };


    if (isModal) {
      document.addEventListener('mousedown', handleModalClickOutside);
    }


    return () => {
      document.removeEventListener('mousedown', handleModalClickOutside);
    };
  }, [isModal, onCancel, handleCancelExpenses]);


  // MODIFICATION: Add useEffect to handle clicks outside the new "Add Field" modal
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showAddModal && addModalRef.current && !addModalRef.current.contains(event.target)) {
        setShowAddModal(false);
      }
    };

    if (showAddModal) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showAddModal]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        ExpdropdownRef.current &&
        !ExpdropdownRef.current.contains(event.target)
      ) {
        setExpIsDropdownOpen(false);
      }
    };


    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const fetchBranchNames = async () => {
      if (!company?.branches || company.branches.length === 0) return;


      try {
        const fetchedBranches = await Promise.all(
          company.branches.map(async (id) => {
            const res = await getBranchDetailsById(id);
            return {
              id,
              name: res?.data?.result?.branchData?.branchName || id,
            };
          })
        );
        setBranchesWithNames(fetchedBranches);
      } catch (error) {
        console.error("Failed to fetch branch names", error);
      }
    };


    fetchBranchNames();
  }, [company?.branches]);


  useEffect(() => {
    const fetchExpenseData = async () => {
      // If initialData is provided as prop, use it directly
      if (initialData) {
        const formatDateForInput = (isoString) => {
          if (!isoString) return "";
          const date = new Date(isoString);
          const tzOffset = date.getTimezoneOffset() * 60000;
          const localISOTime = new Date(date - tzOffset)
            .toISOString()
            .slice(0, 16);
          return localISOTime;
        };


        setFetchedExpenseData(initialData);


        setType(initialData.type || "");
        setDate(
          formatDateForInput(initialData.date) || getCurrentDateTimeLocal()
        );
        setAmount(initialData.amount || "");
        setDescription(initialData.description || "");
        setResourceType(initialData.typeOfResource || "");
        setResourceName(initialData.resourceName || "");
        setCaseNumber(initialData.courtRef || "");


        // Only set documentUrl if there isn't already one from upload
        setDocumentUrl(prevUrl => {
          if (prevUrl) {
            return prevUrl; // Keep the uploaded document
          }
          return initialData.documentUrl || "";
        });


        setBranchId(initialData.branchId || "");
        return;
      }


      // Otherwise, fetch from API if expId exists (route-based)
      if (expId) {
        try {
          const response = await getExpenseByID(expId);
          const expenseData = response?.data?.expenses;


          setFetchedExpenseData(expenseData);
          const formatDateForInput = (isoString) => {
            if (!isoString) return "";
            const date = new Date(isoString);
            const tzOffset = date.getTimezoneOffset() * 60000;
            const localISOTime = new Date(date - tzOffset)
              .toISOString()
              .slice(0, 16);
            return localISOTime;
          };


          setType(expenseData.type || "");
          setDate(
            formatDateForInput(expenseData.date) || getCurrentDateTimeLocal()
          );
          setAmount(expenseData.amount || "");
          setDescription(expenseData.description || "");
          setResourceType(expenseData.typeOfResource || "");
          setResourceName(expenseData.resourceName || "");
          setCaseNumber(expenseData.courtRef || "");


          // Same logic for API-fetched data
          setDocumentUrl(prevUrl => {
            if (prevUrl) {
              return prevUrl; // Keep the uploaded document
            }
            return expenseData.documentUrl || "";
          });


          setBranchId(expenseData?.branchId || "");
        } catch (error) {
          console.error("Failed to fetch expense data:", error);
          showToast("Failed to load expense data.", "error");
        }
      }
    };
    fetchExpenseData();
  }, [expId, initialData?._id]); // Remove initialData from dependency array, only use initialData._id


  // Also add this new state to track if initial data has been loaded
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);


  // And modify the useEffect to use this flag:
  useEffect(() => {
    if (initialDataLoaded) return; // Don't reload if already loaded


    const fetchExpenseData = async () => {
      // If initialData is provided as prop, use it directly
      if (initialData && !initialDataLoaded) {
        const formatDateForInput = (isoString) => {
          if (!isoString) return "";
          const date = new Date(isoString);
          const tzOffset = date.getTimezoneOffset() * 60000;
          const localISOTime = new Date(date - tzOffset)
            .toISOString()
            .slice(0, 16);
          return localISOTime;
        };


        setFetchedExpenseData(initialData);


        setType(initialData.type || "");
        setDate(
          formatDateForInput(initialData.date) || getCurrentDateTimeLocal()
        );
        setAmount(initialData.amount || "");
        setDescription(initialData.description || "");
        setResourceType(initialData.typeOfResource || "");
        setResourceName(initialData.resourceName || "");
        setCaseNumber(initialData.courtRef || "");
        setDocumentUrl(initialData.documentUrl || "");
        setBranchId(initialData.branchId || "");


        setInitialDataLoaded(true); // Mark as loaded
        return;
      }


      // Otherwise, fetch from API if expId exists (route-based)
      if (expId && !initialDataLoaded) {
        try {
          const response = await getExpenseByID(expId);
          const expenseData = response?.data?.expenses;


          setFetchedExpenseData(expenseData);
          const formatDateForInput = (isoString) => {
            if (!isoString) return "";
            const date = new Date(isoString);
            const tzOffset = date.getTimezoneOffset() * 60000;
            const localISOTime = new Date(date - tzOffset)
              .toISOString()
              .slice(0, 16);
            return localISOTime;
          };


          setType(expenseData.type || "");
          setDate(
            formatDateForInput(expenseData.date) || getCurrentDateTimeLocal()
          );
          setAmount(expenseData.amount || "");
          setDescription(expenseData.description || "");
          setResourceType(expenseData.typeOfResource || "");
          setResourceName(expenseData.resourceName || "");
          setCaseNumber(expenseData.courtRef || "");
          setDocumentUrl(expenseData.documentUrl || "");
          setBranchId(expenseData?.branchId || "");


          setInitialDataLoaded(true); // Mark as loaded
        } catch (error) {
          console.error("Failed to fetch expense data:", error);
          showToast("Failed to load expense data.", "error");
        }
      }
    };
    fetchExpenseData();
  }, [expId, initialData?._id, initialDataLoaded]);


  useEffect(() => {
    // Prevent multiple focus attempts
    if (hasFocusedRef.current) return;

    // For editing mode, wait for initial data to load
    // For new expense, focus immediately after component mounts
    const shouldFocus = isEdit ? initialDataLoaded : true;
    
    if (!shouldFocus) return;

    // Add a small delay to ensure DOM is ready
    const focusTimeout = setTimeout(() => {
      const typeSelect = typeSelectRef.current;
      if (typeSelect && !hasFocusedRef.current) {
        typeSelect.focus();
        hasFocusedRef.current = true;
      }
    }, 150);

    return () => clearTimeout(focusTimeout);
  }, [initialDataLoaded, isEdit]); 

  const handleFormKeyDown = (e) => {
    // Check if Enter was pressed and form is valid
    if (e.key === 'Enter' && !e.shiftKey) {
      // Don't submit if we're in certain elements that need Enter for their functionality
      const target = e.target;
      const tagName = target.tagName.toLowerCase();
      const isSelect = tagName === 'select';
      const isTextarea = tagName === 'textarea';
      const isInDropdown = target.closest('.dropdown-content');
      const isInModal = target.closest('.modal') || target.closest('[class*="modal"]');
      const isInCaseSelector = target.closest('.case-selector');
      
      // Allow Enter in selects, textareas, dropdowns, modals, and case selector
      if (isSelect || isTextarea || isInDropdown || isInModal || (isInCaseSelector && ExpisDropdownOpen)) {
      return;
    }

      
      // Prevent default form submission and submit manually if form is valid
      e.preventDefault();
      
      if (isFormValid() && !isSaving) {
        handleSubmit();
      }
    }
  };



  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      handleFileUpload(selectedFile);
    }
  };
  // useEffect(() => {
  //   const fetchExpCases = async () => {
  //     try {
  //       const response =
  //         ExpselectedCourtTab === "high"
  //           ? await getHighCasesByCourtRef()
  //           : ExpselectedCourtTab === "district"
  //           ? await getDistrictCasesByCourtRef()
  //           : await getOtherCourtCasesAddedManuallyByCourtRef();


  //       setExpCases(response.data || []);
  //     } catch (err) {
  //       console.error("Error fetching cases:", err);
  //     }
  //   };


  //   fetchExpCases();
  // }, [ExpselectedCourtTab]);


  useEffect(() => {
    const fetchExpCases = async () => {
      setIsLoadingCases(true); // Start loading
      try {
        const response =
          ExpselectedCourtTab === "high"
            ? await getHighCasesByCourtRef()
            : ExpselectedCourtTab === "district"
              ? await getDistrictCasesByCourtRef()
              : ExpselectedCourtTab === "supreme"
                ? await getSupremeCourtCasesByCourtRef()
                : await getOtherCourtCasesAddedManuallyByCourtRef();


        setExpCases(response.data || []);
      } catch (err) {
        console.error("Error fetching cases:", err);
        setExpCases([]); // Set empty array on error
      } finally {
        setIsLoadingCases(false); // Stop loading
      }
    };


    fetchExpCases();
  }, [ExpselectedCourtTab]);


  const handleCancelUpload = () => {
    setFile(null);
    setDocumentUrl("");
    setUploadProgress(0);
    setUploading(false);
  };
  const handleFileUpload = async (selectedFile) => {
    if (!selectedFile) return;


    setUploading(true);
    setUploadProgress(0);


    try {
      // Generate file path based on company ID
      const filePath = company._id ? `/${company._id}/others` : `/unknown`;


      await uploadFileWithProgress(
        selectedFile,
        filePath,
        // Progress callback
        (progress) => {
          setUploadProgress(progress);
        },
        // Success callback
        (result) => {
          // Use the imageUrl from the utility function
          setDocumentUrl(result.imageUrl); // This is the processed URL part
          setUploading(false);
          showToast("File uploaded successfully!", "success");
        },
        // Error callback
        (error) => {
          console.error("File upload failed:", error);
          setUploading(false);
          setUploadProgress(0);
          showToast(error.message || "File upload failed", "error");
        }
      );
    } catch (error) {
      console.error("File upload failed:", error);
      setUploading(false);
      setUploadProgress(0);
      showToast(error.message || "File upload failed", "error");
    }
  };


  const fileInputRef = useRef(null);
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };


  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCases, setFilteredCases] = useState(ExpCases);
  const inputRef = useRef(null);


  const currencySymbol =
    globalSettings?.result?.[0]?.expenseSettings?.currency === "INR"
      ? "₹"
      : "$";


  const handleCancelExpensesForm = () => {
    if (!isModal) {
      navigate("/home/expenses");
    } else if (onCancel) {
      onCancel();
    } else if (handleCancelExpenses) {
      handleCancelExpenses();
    }
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        ExpdropdownRef.current &&
        !ExpdropdownRef.current.contains(event.target)
      ) {
        setExpIsDropdownOpen(false);
      }
    };


    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  useEffect(() => {
    // Ensure filteredCases is always an array
    let filtered = Array.isArray(ExpCases) ? ExpCases : [];


    if (searchTerm.trim()) {
      filtered = filtered.filter(
        (caseItem) =>
          caseItem.parties?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          caseItem.courtRef?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          caseItem.caseDate?.caseTypeAndNumber
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase())
      );
    }


    setFilteredCases(filtered);
  }, [searchTerm, ExpCases, ExpselectedCourtTab]);


  const getDisplayValue = () => {
    if (searchTerm && ExpisDropdownOpen) {
      return searchTerm;
    }


    // Ensure ExpCases is an array before using .find()
    const casesArray = Array.isArray(ExpCases) ? ExpCases : [];
    const selected = casesArray.find(
      (item) => String(item.courtRef).trim() === String(caseNumber).trim()
    );


    return selected ? `${selected.courtRef}` : caseNumber || "";
  };


  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setExpIsDropdownOpen(true);


    if (value !== getDisplayValue()) {
      setCaseNumber("");
    }
  };


  const handleInputFocus = () => {
    setExpIsDropdownOpen(true);
    setSearchTerm("");
  };

  const handleCaseSelectWithFocus = (caseItem) => {
    setCaseNumber(caseItem.courtRef);
    setSearchTerm("");
    setExpIsDropdownOpen(false);
  };

  const handleCaseSelect = (caseItem) => {
    handleCaseSelectWithFocus(caseItem);
  };

  const handleClearCase = () => {
    setCaseNumber("");
    setSearchTerm("");
    setExpIsDropdownOpen(false);
  };

  const handleModalKeyDown = (e) => {
    if (e.key === 'Enter' && newFieldValue.trim() && !isAddingNewField) {
      e.preventDefault();
      handleAddNewFieldConfirm();
    }
  };


  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      setExpIsDropdownOpen(false);
      inputRef.current?.blur();
    } else if (
      e.key === "Enter" &&
      Array.isArray(filteredCases) &&
      filteredCases.length === 1
    ) {
      handleCaseSelect(filteredCases[0]);
    }
  };
  const handleAddNewFieldConfirm = async () => {
    if (!newFieldValue.trim()) return;


    setIsAddingNewField(true);


    try {
      const fieldMap = {
        type: "expenseTypes",
        resourceType: "resourceTypes",
        resourceName: "resourceName",
      };


      const fieldKey = fieldMap[addFieldType];
      const currentExpenseSettings =
        globalSettings?.result?.[0]?.expenseSettings || {};
      const existingValues = currentExpenseSettings[fieldKey] || [];


      if (existingValues.includes(newFieldValue.trim())) {
        showToast(
          `${newFieldValue.trim()} already exists in ${addFieldType}`,
          "info"
        );
        setIsAddingNewField(false);
        return;
      }


      const updatedExpenseSettings = {
        ...currentExpenseSettings,
        [fieldKey]: [...existingValues, newFieldValue.trim()],
      };


      const payload = {
        [fieldKey]: [...existingValues, newFieldValue.trim()],
      };


      await updateExpenseSettings(payload);
      showToast(`New ${addFieldType} added successfully!`, "success");
      const updatedSettings = {
        ...globalSettings,
        result: globalSettings.result.map((setting) => ({
          ...setting,
          expenseSettings: {
            ...setting.expenseSettings,
            [fieldKey]: [...existingValues, newFieldValue.trim()],
          },
        })),
      };
      setGlobalSettings(updatedSettings);


      const formattedValue = newFieldValue.trim().toLowerCase();
      if (addFieldType === "type") setType(formattedValue);
      if (addFieldType === "resourceType") setResourceType(formattedValue);
      if (addFieldType === "resourceName") setResourceName(formattedValue);


      setNewFieldValue("");
      setShowAddModal(false);
    } catch (err) {
      console.error("Failed to add field", err);
      showToast("Failed to add new item.", "error");
    } finally {
      setIsAddingNewField(false);
    }
  };


  const isFormValid = () => {
    if (!type || type === "") return false;
    if (!date || date === "") return false;
    if (!amount || amount === "" || Number(amount) <= 0) return false;
    if (!description || description.trim() === "") return false;
    if (!resourceType || resourceType.trim() === "") return false;
    // if (isEnt && (!branchId || branchId.trim() === "")) return false;
    if (uploading) return false;
    return true;
  };
  const [isSaving, setIsSaving] = useState(false);


  useEffect(() => {
    console.trace(); // This will show the call stack when documentUrl changes
  }, [documentUrl]);


  const handleSubmit = async () => {

    
    if (!isFormValid()) {
      showToast("All required fields must be filled!", "error");
      return;
    }


    if (isSaving) return;
    setIsSaving(true);


    const payload = {
      type,
      date,
      amount: Number(amount),
      description,
      typeOfResource: resourceType,
      resourceName,
      courtRef: caseNumber,
      documentUrl,
      ...(isEnt && { branchId }),
    };


    try {
      const response = isEdit
        ? await updateExpense(payload, currentExpenseId)
        : await saveExpense(payload);


      // Only clear form state AFTER successful submission
      setType("");
      setDate("");
      setAmount("");
      setDescription("");
      setResourceType("");
      setResourceName("");
      setCaseNumber("");
      setDocumentUrl("");
      setFile(null);
      setUploadProgress(0);

      hasFocusedRef.current = false;


      showToast(
        `Expense ${isEdit ? "updated" : "saved"} successfully!`,
        "success"
      );
      onSuccess && onSuccess(caseNumber);


      if (!isModal) {
        navigate("/home/expenses");
      }
    } catch (error) {
      console.error("Failed to save/update expense:", error);
      showToast(`Failed to ${isEdit ? "update" : "save"} expense`, "error");
      // Don't clear form state on error
    } finally {
      setIsSaving(false);
    }
  };
  return (
    <div
      className={`expense-form-container ${isModal ? "modal-expense-form-container" : " "
        }`}
      ref={modalRef}
      onKeyDown={handleFormKeyDown}
    >
      <div
        className={`expense-form-card ${isModal ? "modal-expense-form-card" : " "
          }`}
      >
        <h1
          className={`expense-form-title ${isModal ? "modal-expense-form-title" : " "
            }`}
        >
          {isEdit ? "Update Expense Details" : "Create New Expense"}
        </h1>


        {isModal && (
          <button
            className="expense-form-close-button"
            onClick={handleCancelExpensesForm}
            aria-label="Close"
          >
            &times;
          </button>
        )}


        <hr className="expense-form-divider" />


        {/* Basic Information Section */}
        <div className="form-section">
          <h3>Basic Information</h3>


          <div className="expense-form-group">
            <label className="expense-form-label">Type <span className="expense-form-required">*</span></label>
            <div className="expense-form-input-container">
              <select
              ref={typeSelectRef}
                name="type"
                className="expense-form-form-select"
                value={type}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "__add_new__") {
                    setAddFieldType("type");
                    setShowAddModal(true);
                  } else {
                    setType(val);
                  }
                }}
              >
                <option value="">Select type</option>
                {(
                  globalSettings?.result?.[0]?.expenseSettings?.expenseTypes ||
                  []
                ).map((t) => (
                  <option key={t} value={t.toLowerCase()}>
                    {t}
                  </option>
                ))}
                <option value="__add_new__">+ Add New Type</option>
              </select>
            </div>
          </div>


          <div className="expense-form-flex-row">
            <div className="expense-form-col-half">
              <label className="expense-form-label">
                Date <span className="expense-form-required">*</span>
              </label>
              <input
                type="datetime-local"
                name="date"
                className="expense-form-input-date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>


            <div className="expense-form-col-half">
              <label className="expense-form-label">
                Amount <span className="expense-form-required">*</span>
              </label>
              <div className="expense-form-input-container">
                <input
                  type="number"
                  name="amount"
                  className="expense-form-input no-spinner"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  onWheel={(e) => e.target.blur()}
                  placeholder="Enter amount"
                />
                <div className="expense-form-icon-container">
                  <span>{currencySymbol}</span>
                </div>
              </div>
            </div>
          </div>


          <div className="expense-form-group">
            <label className="expense-form-label">
              Description <span className="expense-form-required">*</span>
            </label>
            <textarea
              name="description"
              className="expense-form-form-textarea"
              rows="3"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter expense description"
            />
          </div>
        </div>


        {/* Resource Information Section */}
        <div className="form-section">
          <h3>Resource Information</h3>


          <div className="expense-form-flex-row">
            <div className="expense-form-col-half">
              <label className="expense-form-label">
                Type of Resource{" "}
                <span className="expense-form-required">*</span>
              </label>
              <div className="expense-form-input-container">
                <select
                  name="resourceType"
                  className="expense-form-form-select"
                  value={resourceType}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val === "__add_new__") {
                      setAddFieldType("resourceType");
                      setShowAddModal(true);
                    } else {
                      setResourceType(val);
                    }
                  }}
                >
                  <option value="">Select resource type</option>
                  {(
                    globalSettings?.result?.[0]?.expenseSettings
                      ?.resourceTypes || []
                  ).map((r) => (
                    <option key={r} value={r.toLowerCase()}>
                      {r}
                    </option>
                  ))}
                  <option value="__add_new__">+ Add New Resource Type</option>
                </select>
              </div>
            </div>


            <div className="expense-form-col-half">
              <label className="expense-form-label">Resource Name</label>
              <div className="expense-form-input-container">
                <select
                  name="resourceName"
                  className="expense-form-form-select"
                  value={resourceName}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val === "__add_new__") {
                      setAddFieldType("resourceName");
                      setShowAddModal(true);
                    } else {
                      setResourceName(val);
                    }
                  }}
                >
                  <option value="">Select resource name</option>
                  {(
                    globalSettings?.result?.[0]?.expenseSettings
                      ?.resourceName || []
                  ).map((r) => (
                    <option key={r} value={r.toLowerCase()}>
                      {r}
                    </option>
                  ))}
                  <option value="__add_new__">+ Add New Resource Name</option>
                </select>
              </div>
            </div>
          </div>
        </div>


        {/* Case Selection Section */}
        <div className="form-section">
          <h3>Case Association</h3>


          <div className="form-group">
            <div className="case-selector" ref={ExpdropdownRef}>
              <label>Select Case:</label>
              <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                <input
                  ref={inputRef}
                  type="text"
                  value={getDisplayValue()}
                  onChange={handleInputChange}
                  onFocus={handleInputFocus}
                  //onKeyDown={handleKeyDown}

                  onKeyDown={(e) => {
                    if (e.key === "Escape") {
                      setExpIsDropdownOpen(false);
                      inputRef.current?.blur();
                    } else if (
                      e.key === "Enter" &&
                      Array.isArray(filteredCases) &&
                      filteredCases.length === 1
                    ) {
                      e.preventDefault(); // Prevent form submission
                      handleCaseSelectWithFocus(filteredCases[0]); // Use updated function
                    }
                  }}
                  className="custom-dropdown-input"
                  placeholder="Type to search cases..."
                  autoComplete="off"
                  disabled={disabledCourtRef && isModal && caseNumber}
                />
                {caseNumber && !(disabledCourtRef && isModal) && (
                  <button
                    type="button"
                    onClick={handleClearCase}
                    className="clear-case-button"
                    aria-label="Clear selection"
                    title="Clear selection"
                  >
                    ×
                  </button>
                )}
              </div>


              {ExpisDropdownOpen && !(disabledCourtRef && isModal && caseNumber) && (
                <div className="dropdown-content">
                  <div className="dropdown-tabs">
                    <button
                      type="button"
                      className={ExpselectedCourtTab === "high" ? "active" : ""}
                      onClick={() => setExpSelectedCourtTab("high")}
                    >
                      High Court
                    </button>
                    <button
                      type="button"
                      className={
                        ExpselectedCourtTab === "district" ? "active" : ""
                      }
                      onClick={() => setExpSelectedCourtTab("district")}
                    >
                      District Court
                    </button>
                    <button
                      type="button"
                      className={
                        ExpselectedCourtTab === "other" ? "active" : ""
                      }
                      onClick={() => setExpSelectedCourtTab("other")}
                    >
                      Other Court
                    </button>
                    <button
                      type="button"
                      className={
                        ExpselectedCourtTab === "supreme" ? "active" : ""
                      }
                      onClick={() => setExpSelectedCourtTab("supreme")}
                    >
                      Supreme Court
                    </button>
                  </div>


                  {/* <div className="dropdown-options">
                    {searchTerm &&
                      (!Array.isArray(filteredCases) ||
                        filteredCases.length === 0) &&
                      Array.isArray(ExpCases) &&
                      ExpCases.length > 0 && (
                        <div className="no-data">
                          No cases found matching "{searchTerm}"
                        </div>
                      )}


                    {(!Array.isArray(filteredCases) ||
                      filteredCases.length === 0) &&
                    !searchTerm ? (
                      <div className="no-data">No cases found.</div>
                    ) : (
                      Array.isArray(filteredCases) &&
                      filteredCases.map((caseItem, index) => (
                        <div
                          key={index}
                          className={`dropdown-option ${
                            caseItem.courtRef === caseNumber ? "selected" : ""
                          }`}
                          onClick={() => handleCaseSelect(caseItem)}
                        >
                          <div className="case-info">
                            <div className="case-parties">
                              {caseItem.parties || "No parties info"}
                            </div>
                            <div className="case-ref">{caseItem.courtRef}</div>
                            {caseItem.caseDate?.caseTypeAndNumber && (
                              <div className="case-number">
                                {caseItem.caseDate.caseTypeAndNumber}
                              </div>
                            )}
                          </div>
                        </div>
                      ))
                    )}
                  </div> */}
                  <div className="dropdown-options">
                    {isLoadingCases ? (
                      <div className="loading-state">Loading cases...</div>
                    ) : (
                      <>
                        {searchTerm &&
                          (!Array.isArray(filteredCases) ||
                            filteredCases.length === 0) &&
                          Array.isArray(ExpCases) &&
                          ExpCases.length > 0 && (
                            <div className="no-data">
                              No cases found matching "{searchTerm}"
                            </div>
                          )}


                        {(!Array.isArray(filteredCases) ||
                          filteredCases.length === 0) &&
                          !searchTerm ? (
                          <div className="no-data">
                            No {ExpselectedCourtTab} court cases available
                          </div>
                        ) : (
                          Array.isArray(filteredCases) &&
                          filteredCases.map((caseItem, index) => (
                            <div
                              key={index}
                              className={`dropdown-option ${caseItem.courtRef === caseNumber ? "selected" : ""
                                }`}
                              onClick={() => handleCaseSelectWithFocus(caseItem)}
                            >
                              <div className="case-info">
                                <div className="case-parties">
                                  {caseItem.parties || "No parties info"}
                                </div>
                                <div className="case-ref">{caseItem.courtRef}</div>
                                {caseItem.caseDate?.caseTypeAndNumber && (
                                  <div className="case-number">
                                    {caseItem.caseDate.caseTypeAndNumber}
                                  </div>
                                )}
                              </div>
                            </div>
                          ))
                        )}
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>


        {/* Branch Selection (Enterprise Only) */}
        {isEnt && (
          <div className="form-section">
            <h3>Branch Information</h3>


            <div className="expense-form-group">
              <label className="expense-form-label">
                Branch
              </label>
              <select
                className="expense-form-input"
                value={branchId}
                onChange={(e) => setBranchId(e.target.value)}
                disabled={isEdit}
              >
                <option value="">Select Branch</option>
                {branchesWithNames.map((branch) => (
                  <option key={branch.id} value={branch.id}>
                    {branch.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}


        {/* Document Upload Section */}
        <div className="form-section">
          <h3>Supporting Documents</h3>


          <div className="expense-form-group">
            <div className="form-group upload-document-group">
              <label className="expense-form-label">Upload Document</label>
              <div
                className="upload-document-container"
                onClick={handleUploadClick}
                role="button"
                tabIndex={0}
                onKeyPress={(e) => {
                  if (e.key === "Enter") handleUploadClick();
                }}
              >
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
                <div className="upload-icon-container">
                  <BiUpload size={24} color="#0066cc" />
                  <span>Click to upload</span>
                </div>
              </div>


              {uploading && (
                <div className="upload-progress">
                  <div className="progress-bar">
                    <div
                      className="progress"
                      style={{ width: `${uploadProgress}%` }}
                    />
                  </div>
                  <span>{Math.round(uploadProgress)}% uploaded</span>
                </div>
              )}

              {documentUrl && !uploading && (
                <div className="uploaded-file">
                  <a
                    href={`${process.env.REACT_APP_BACKEND_MAIN_URL_PATH}ftp/view/${documentUrl}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {file ? file.name : "View Uploaded Document"}
                  </a>
                  <button
                    type="button"
                    onClick={handleCancelUpload}
                    className="cancel-upload-button"
                  >
                    Delete Document
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>


        <div className="expense-form-button-container">
          <button
            onClick={handleSubmit}
            className="expense-form-btn expense-form-btn-save"
            disabled={!isFormValid() || isSaving}
          >
            {isSaving ? "Saving..." : "Save"}
          </button>
          <button
            onClick={handleCancelExpensesForm}
            className="expense-form-btn-cancel"
            disabled={isSaving}
          >
            Cancel
          </button>
        </div>
      </div>


      {showAddModal && (
        <div className="confirmation-modal-backdrop">
          <div className="confirmation-modal notinvoice" ref={addModalRef}>
            <button
              className="branch-form-close-button"
              onClick={() => setShowAddModal(false)}
              aria-label="Close"
            >
              &times;
            </button>

            <div className="add-new-field-modal-content">
              <h3>
                {addFieldType === "type"
                  ? "Add New Type"
                  : addFieldType === "resourceType"
                  ? "Add New Resource Type"
                  : addFieldType === "resourceName"
                  ? "Add New Resource Name"
                  : `Add New ${addFieldType}`}
              </h3>

              <input
                type="text"
                placeholder={`Enter new ${addFieldType}`}
                value={newFieldValue}
                onChange={(e) => setNewFieldValue(e.target.value)}
                className="add-new-field-input"
                onKeyDown={handleModalKeyDown}
                autoFocus
              />
            </div>

            <div className="confirmation-actions notinvoice">
              {/* <button
                className="cancel-btn"
                onClick={() => setShowAddModal(false)}
                disabled={isAddingNewField}
              >
                Cancel
              </button> */}
              <button
                className="confirm-btn"
                onClick={handleAddNewFieldConfirm}
                disabled={!newFieldValue.trim() || isAddingNewField}
              >
                {isAddingNewField ? "Adding..." : "Add"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};